import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HowToBuyItem } from 'src/app/shared/interfaces/product.model';

@Component({
  selector: 'bz-help-center',
  templateUrl: './bz-help-center.component.html',
  styleUrls: ['./bz-help-center.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BzHelpCenterComponent {

  @Input() public heading: string = "";
  @Input() public items: HowToBuyItem[] = [];

  readonly imagesPath: string[] = [
    '../../../../assets/illustration_1.svg',
    '../../../../assets/search-step.svg',
    '../../../../assets/illustration_3.svg',
    '../../../../assets/illustration_7.svg',
    '../../../../assets/illustration_4.svg',
    '../../../../assets/order-step.svg'
  ];

}
